import { render, staticRenderFns } from "./AdItemCarousel.vue?vue&type=template&id=6b9241b6&"
import script from "./AdItemCarousel.vue?vue&type=script&lang=ts&"
export * from "./AdItemCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports